import type { ToastsState } from 'redux/modules/toasts.types';
import { addToast, dismissToast, persistToast } from 'redux/modules/toasts.types';
import { reducerWithInitialState } from 'typescript-fsa-reducers';

const initialState: ToastsState = {
  entries: [],
};

const toastsReducer = reducerWithInitialState(initialState)
  .caseWithAction(addToast, (state, action) => {
    return {
      ...state,
      entries: state.entries
        .concat(action.payload)
        .sort((a, b) => (a.dismissAfter ? 1 : 0) - (b.dismissAfter ? 1 : 0)),
    };
  })
  .caseWithAction(dismissToast, (state, action) => ({
    ...state,
    entries: state.entries.filter(toast => toast.key !== action.payload.key),
  }))
  .case(persistToast, (state, { key }) => {
    const toasts = state.entries.slice();
    const index = toasts.findIndex(toast => toast.key === key);
    if (index === -1) return state;

    toasts.splice(index, 1, { ...toasts[index], dismissAfter: 0 });
    return {
      ...state,
      entries: toasts,
    };
  });

export default toastsReducer;
